export default {
  props: {
    type: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    arrow: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: 'sushi',
    },
    selected: {
      type: Boolean,
      default: false,
    },
    filtersSelected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classModifier() {
      return {
        'market-filters-menu-button': true,
        'market-filters-menu-button--active': this.active,
        'market-filters-menu-button--arrow': this.arrow,
        'market-filters-menu-button--selected': this.selected,
        'market-filters-menu-button--filters-selected': this.filtersSelected,
        [`market-filters-menu-button--${this.theme}`]: this.theme,
        [`market-filters-menu-button--${this.type}`]: this.type,
      };
    },
  },
  methods: {
    click(e) {
      e.stopPropagation();
      this.$emit('click', this.type);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-filters/menu-button/menu-button.js